export default __webpack_public_path__ + "static/chumash_bunker-f4b5d89123f6277be49a88207687fd74.png";